import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../scss/custom.scss';
import {
  ComboBox,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormLabel,
  FormGroup,
  DataTableSkeleton,
  Dropdown,
  DropdownSkeleton,
  Button,
  TableToolbar,
  Loading,
} from 'carbon-components-react';
import Add16 from '@carbon/icons-react/lib/add/16';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import Attachment16 from '@carbon/icons-react/lib/attachment/16';
import { Calendar16, Download16 } from '@carbon/icons-react';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import EDrillDetails from './EDrillDetails';
import EDrillMultiSelectDataTable from './EDrillMultiSelectDataTable';
import DrillFilterModal from './DrillFilterModal';
import EDrillPlanModificationModal from './EDrillPlanModificationModal';
import EDrillWorkSiteAttachmentModal from './EDrillWorkSiteAttachmentModal';
import { drill, api, me } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEnabled, IsInRole } from '../../helpers/authorization/Policies';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { InspectionMonthHeader } from '../inspection/common/InspectionMonthHeader';
import { CalendarSkeleton } from '../inspection/inspectionReport/common/CalendarSkeleton';
import { getError, getSuccess, entitiesLabels, apioperation, PlannedWeekChangeType } from '../../helpers/Constants';
import DrillRepository from '../../helpers/api/DrillRepository';
import { EDLegendTable } from './EDLegendTable';
import { LegendType } from './common/EDLegendType';
import { WarningModal } from '../common/WarningModal';


export default class EmergencyDrillList extends Component {
  constructor(props) {
    super(props);
    this.showAddEDrill = this.showAddEDrill.bind(this);
    this.showEditEDrill = this.showEditEDrill.bind(this);
    this.buildFilter = this.buildFilter.bind(this);
    this.newEDrillAdded = this.newEDrillAdded.bind(this);
    this.eDrillUpdated = this.eDrillUpdated.bind(this);
    this.eDrillPlannedUpdated = this.eDrillPlannedUpdated.bind(this);
    this.onCancelEDrillPlannedModification = this.onCancelEDrillPlannedModification.bind(this);
    this.onSaveEDrillPlannedModification = this.onSaveEDrillPlannedModification.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.toogleCalendar = this.toogleCalendar.bind(this);
    this.toogleFilterModal = this.toogleFilterModal.bind(this);
    this.onYearChange = this.onYearChange.bind(this);
    this.handleChangePaging = this.handleChangePaging.bind(this);
    this.filterByWeek = this.filterByWeek.bind(this);
    this.filterByMonths = this.filterByMonths.bind(this);
    this.toggleWorksiteModal = this.toggleWorksiteModal.bind(this);
    this.closeWorksiteModal = this.closeWorksiteModal.bind(this);
    this.handleChangeWorksite = this.handleChangeWorksite.bind(this);
    this.onConfirmWorksiteModal = this.onConfirmWorksiteModal.bind(this);
    this.toggleEDrillWorkSiteAttachmentModal = this.toggleEDrillWorkSiteAttachmentModal.bind(this);
    this.onCloseWorkSiteAttachmentModal = this.onCloseWorkSiteAttachmentModal.bind(this);
    this.getWorkSiteAttachment = this.getWorkSiteAttachment.bind(this);
    this.toggleDownloadAnnualReportModal = this.toggleDownloadAnnualReportModal.bind(this); // RITM0860478
    this.closeDownloadAnnualReportModal = this.closeDownloadAnnualReportModal.bind(this); // RITM0860478
    this.onConfirmDownloadAnnualDrillPlanModal = this.onConfirmDownloadAnnualDrillPlanModal.bind(this); // RITM0860478

    this.state = {
      idEDrill: null,
      eDrillToModify: null,
      isLoadingYear: true,
      items: [],
      originalItems: [],
      modalEDrillVisible: false,
      modalEDrillPlanModificationVisible: false,
      isLoadingApproverOptions: false,
      calendar: [],
      isOpenCalendar: true,
      isBack: (this.props.history.action === 'POP' || this.props.location.search === '?isBack'),
      isWarningModalOpen: false,
      warningMessage: '',
      isLoadingModifiedPlannedWeekSetCompiler: false,
      currentModifiedPlannedWeekSetCompiler: null,
      // filter
      isOpenSearchForm: false,
      years: [],
      searchModel: {
        ...this.searchProp(),
        needToChange: true,
      },

      // pagination
      paginationInfo: {
        currentPage: 1,
        pageSize: 10,
        rowCount: 0,
      },

      // loading
      isLoadingTable: false,
      isLoadingCalendar: false,
      isLoadingWorksite: false,
      isLoadingDPWorksites: false,
      isLoadingDPProjects: false,
      isSubmitted: false,
      isWorksiteModalOpen: false,
      isEDrillWorkSiteAttachmentModalOpen: false,
      isDownloadAnnualReportOpen: false, // RITM0860478
      isDownloadingAnnualDrillPlanFile: false, // RITM0860478

      monthsSelected: [],
      weeksSelected: [],
      modifiedPlannedWeekSet: {
        approvers: [],
        approver: null,
        deletedPlannedWeek: [],
        addedPlannedWeek: [],
        updatedPlannedWeek: []
      },
      worksites: [],
      dpWorksites: [],
      dpProjects: [],
      selectedWorksite: null,
      selectedDPWorksite: null,
      selectedDPProject: null,
      worksiteAttachments: []
    };
  
    this.year = new Date().getFullYear();
    console.log(`EmergencyDrillList.constructor: this.year: ${this.year}`);
    this.years = this.getYears();
    this.month = new Date().getMonth();
    this.weeks = moment().weeks();
    this.validator = new SimpleReactValidator();
    this.validatorworksite = new SimpleReactValidator();
  }


  // ************* HOOKS ************* START
  async componentDidMount() {
    console.log(`EmergencyDrillList.componentDidMount:`);
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({
      items,
      originalItems: items,
      loading: false,
    });
    this.getYears();
    this.getUserWorksite();
  }
  // ************* HOOKS ************* END

  onDelete = async (items) => {
    this.setState(
      (prevState) => ({
        originalItems: prevState.originalItems.filter((item) => {
          const deletedId = items.map((filter) => filter.id);
          const itemId = item.id;
          return !deletedId.includes(itemId);
        }),
      }),
      () => {
        this.setState((state) => ({
          items: this.buildFilter(state.originalItems, null, null),
        }));
      }
    );
  };

  onCancelEDrillPlannedModification() {
    this.validator.hideMessages();
    this.forceUpdate();
    this.setState((prevState) => ({
        modalEDrillPlanModificationVisible: !prevState.modalEDrillPlanModificationVisible,
        modifiedPlannedWeekSet: {
          approvers: [],
          approver: null,
          deletedPlannedWeek: [],
          addedPlannedWeek: [],
          updatedPlannedWeek: []
        }
      }));
  }

  async onSaveEDrillPlannedModification() {
    if (this.validator.allValid()) {
      try {
        this.setState((prevState) => (
          { modalEDrillPlanModificationVisible: !prevState.modalEDrillPlanModificationVisible }));
        this.setState(() => ({ isSubmitted: true }));
        const modifiedPlannedWeekSetData = {
          idDrillPlan: this.state.eDrillToModify.id,
          idDataApprover: this.state.modifiedPlannedWeekSet.approver.id,
          drillModifiedPlannedWeeks: [...this.state.modifiedPlannedWeekSet.deletedPlannedWeek, 
                                      ...this.state.modifiedPlannedWeekSet.addedPlannedWeek, 
                                      ...this.state.modifiedPlannedWeekSet.updatedPlannedWeek]
        };
        await api.post('drill/drillmodifiedplannedweekset', modifiedPlannedWeekSetData);
        showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES, apioperation.POST));
      } catch (error) {
        if (error.response) {
          const message = error.response.data || '';
          if (error.response.status === 501) showNotification.error(`${entitiesLabels.ERROR}`, `${entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES} ${message}`);
          else showNotification.error(`${entitiesLabels.ERROR}`, null);
        }
      } finally {
        this.setState(() => ({ isSubmitted: false }));
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  onApproverSelect = (selectedItem) => {
    this.setState((prevState) => 
      ({ modifiedPlannedWeekSet: { ...prevState.modifiedPlannedWeekSet, 
        approver: selectedItem } }));
  };

  onUpdateReasonForChange = (type, el) => {
    let idx = -1;
    switch (type) {
      case PlannedWeekChangeType.ToAdd:
        idx = this.state.modifiedPlannedWeekSet.addedPlannedWeek
          .findIndex((item) => el.target.id === item.id);
        if (idx !== -1) {
          const itemsA = [...this.state.modifiedPlannedWeekSet.addedPlannedWeek];
          const itemA = { ...itemsA[idx] };
          itemA.reasonForChange = el.target.value;
          itemsA[idx] = itemA;
          this.setState((prevState) => ({ modifiedPlannedWeekSet: 
                                          { ...prevState.modifiedPlannedWeekSet, 
                                            addedPlannedWeek: [...itemsA] } }));
        }
        break;
      case PlannedWeekChangeType.ToChange:
        idx = this.state.modifiedPlannedWeekSet.updatedPlannedWeek
          .findIndex((item) => el.target.id === item.id);
        if (idx !== -1) {
          const itemsU = [...this.state.modifiedPlannedWeekSet.updatedPlannedWeek];
          const itemU = { ...itemsU[idx] };
          itemU.reasonForChange = el.target.value;
          itemsU[idx] = itemU;
          this.setState((prevState) => ({ modifiedPlannedWeekSet: 
                                          { ...prevState.modifiedPlannedWeekSet, 
                                            updatedPlannedWeek: [...itemsU] } }));
        }
        break;
      case PlannedWeekChangeType.ToDelete:
        idx = this.state.modifiedPlannedWeekSet.deletedPlannedWeek
          .findIndex((item) => el.target.id === item.id);
        if (idx !== -1) {
          const itemsD = [...this.state.modifiedPlannedWeekSet.deletedPlannedWeek];
          const itemD = { ...itemsD[idx] };
          itemD.reasonForChange = el.target.value;
          itemsD[idx] = itemD;
          this.setState((prevState) => ({ modifiedPlannedWeekSet: 
                                          { ...prevState.modifiedPlannedWeekSet, 
                                            deletedPlannedWeek: [...itemsD] } }));
        }
        break;
      default:
        break;
    }
  };
  //  *************** FILTERS *************** START

  onYearChange(selectedItem) {
    this.setState(
      {
        searchModel: {
          ...this.searchProp(),
          calendarInfo: {
            plannedWeeks: [],
            monthNumbers: [],
            referenceYear: this.year,
          },
          needToChange: true,
          calendar: [],
        },
        isfilterByWeek: false,
        isBack: false,
      }, () => {
      let year;
      try {
        year = selectedItem.selectedItem;
        console.log(`EmergencyDrillList.onYearChange: year: ${year}`);
        this.getYears(year);
        const statusCopy = { ...this.state };
        statusCopy.searchModel.calendarInfo.referenceYear = year;
        statusCopy.isBack = false;
        statusCopy.searchModel.needToChange = true;
        this.setState(statusCopy);
        this.getCalendar({ page: 1 }, false);
      } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.YEAR, apioperation.GET));
        year = this.state.years;
      } finally {
        this.setState({ loading: true, filteredMonth: null });
        //  const items = await this.getItems(year);
        this.setState((prevState) => ({
          searchModel: {
            ...prevState.searchModel,
            needToChange: false,
            calendarInfo: {
              ...prevState.searchModel.calendarInfo,
              referenceYear: year,
            },
          },
        }));
      }
    }
    );
  }

  getModifiedPlannedWeekSetCompiler = (idCompiler, func) => {
    if (idCompiler == null) return;

    this.setState(() => ({ isLoadingModifiedPlannedWeekSetCompiler: true }));
    api.get('/users/', idCompiler)
      .then((response) => func(response.data))
      .catch(() => {
        showNotification.error(`${entitiesLabels.ERROR}`, `Error getting compiler of ${entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES}`);
    })
    .finally(() => {
      this.setState(() => ({ isLoadingModifiedPlannedWeekSetCompiler: false }));
    });
  }

  getApprovers = (idEntity) => {
    me.getWithParam('users', {
      params: { Role: 'Data Approver', IdEntity: idEntity, includeAdmins: true },
    })
      .then((response) => {
        this.setState((prevState) => ({
            modifiedPlannedWeekSet: {
              ...prevState.modifiedPlannedWeekSet,
              approvers: response.data
            },
            isLoadingApproverOptions: false,
          }));
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, '', 'ERROR'));
      })
      .finally(() => {
        this.setState(() => ({
            isLoadingApproverOptions: false
          }));
      });
  };

  // ************* API ************* START
  getItems = async () => {
    const items = [];
    try {
      this.getCalendar();
      // items = (await api.getAll(`/drill`)).data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, 'loading Emergency Drill', 'ERROR'));
    }
    return items;
  };
  // ************* API ************* END
  
  getHashtag = () => {
    if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
      return decodeURIComponent(this.props.location.hash.substring(1));
    }
    return null;
  };

  getYears = (selectYear) => {
    console.log(`EmergencyDrillList.getYears: this.year: ${this.year}`);
    drill.drillYears
      .getAll()
      .then((response) => {
        this.setState({ years: response.data });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DRILLSAVAILABLEYEARS, apioperation.GET));
      });
    };
  //End

  getUserWorksite = () => {
    this.setState({
      isLoadingWorksite: true,
    });
    me.getAll('worksites')
      .then((response) => {
        this.setState({
          worksites: response.data,
          isLoadingWorksite: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
        this.setState({
          isLoadingWorksite: false,
        });
      });
  };

  // RITM0860478
  getDPWorksites = () => {
    const smRefYear = this.state.searchModel?.referenceYear;
    const smCalRefYear = this.state.searchModel?.calendarInfo?.referenceYear;
    console.log(`EmergencyDrillList.getDPWorksites: this.year: ${this.year} smRefYear: ${smRefYear} smCalRefYear: ${smCalRefYear}`);
    this.setState({
      isLoadingDPWorksites: true,
    });
    drill.getDrillsWorksites(smCalRefYear)
      .then((response) => {
        this.setState({
          dpWorksites: response.data,
          isLoadingDPWorksites: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
        this.setState({
          isLoadingDPWorksites: false,
        });
      });
  };

  // RITM0860478
  getDPProjects = () => {
    const smRefYear = this.state.searchModel?.referenceYear;
    const smCalRefYear = this.state.searchModel?.calendarInfo?.referenceYear;
    console.log(`EmergencyDrillList.getDPProjects: this.year ${this.year} smRefYear: ${smRefYear} smCalRefYear: ${smCalRefYear}`);
    this.setState({
      isLoadingDPProjects: true,
    });
    drill.getDrillsProjects(smCalRefYear)
      .then((response) => {
        this.setState({
          dpProjects: response.data,
          isLoadingDPProjects: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
        this.setState({
          isLoadingDPProjects: false,
        });
      });
  };

  async eDrillUpdated(eDrillPlan) {
    console.log(`EmergencyDrillList.eDrillUpdated: this.year: ${this.year}`);
    await DrillRepository.updateCachedDrillList(eDrillPlan, eDrillPlan.plannedYear);
    const drills = await DrillRepository.getCachedDrillList(
      this.state.searchModel.calendarInfo.referenceYear
    );
    //  const itemList = this.state.originalItems.filter((item) => item.id !== eDrillPlan.id);
    //  itemList.unshift(eDrillPlan);

    this.setState((prevState) => ({
      originalItems: drills.itemList,
      items: this.buildFilter(drills.itemList, null, null),
      modalEDrillVisible: !prevState.modalEDrillVisible,
      searchModel: {
        ...prevState.searchModel,
        needToChange: true,
      },
    }));

    this.getCalendar();
  }


  //  *************** FILTERS *************** END

  //  *************** CALENDAR *************** START

  toogleCalendar() {
    this.setState((oldState) => ({ isOpenCalendar: !oldState.isOpenCalendar }));
  }

  toggleIsSubmitted = () => {
    this.setState((prevState) => ({ isSubmitted: !prevState.isSubmitted }));
  }

  toggleWorksiteModal = () => {
    this.setState((prevState) => ({ isWorksiteModalOpen: !prevState.isWorksiteModalOpen }));
  }

  // RITM0860478
  toggleDownloadAnnualReportModal = () => {
    this.setState((prevState) => ({ isDownloadAnnualReportOpen: !prevState.isDownloadAnnualReportOpen }));
    console.log(`EmergencyDrillList.toggleDownloadAnnualReportModal: isDownloadAnnualReportOpen: ${this.state?.isDownloadAnnualReportOpen}`);

  }
  
  closeWorksiteModal = () => {
    this.validatorworksite.hideMessages();
    this.setState(() => ({ selectedWorksite: null }));
    this.toggleWorksiteModal();
  }

  // RITM0860478
  closeDownloadAnnualReportModal = () => {
    console.log(`EmergencyDrillList.closeDownloadAnnualReportModal`);
    this.setState(() => ({ selectedDPWorksite: null }));
    this.setState(() => ({ selectedDPProject: null }));
    this.toggleDownloadAnnualReportModal();
  }

  onConfirmWorksiteModal = () => {
    if (this.validatorworksite.allValid()) {
      this.getWorkSiteAttachment();
      this.toggleWorksiteModal();
      this.toggleEDrillWorkSiteAttachmentModal();
    } else {
      this.validatorworksite.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, ` ${entitiesLabels.WORKSITE} required fields are missing `);
      this.forceUpdate();
    }
  }

  // RITM0860478
  onConfirmDownloadAnnualDrillPlanModal = () => {
    console.log(`EmergencyDrillList.onConfirmDownloadAnnualDrillPlanModal: selectedDPWorksite: ${this.state.selectedDPWorksite} selectedDPProject: ${this.state.selectedDPProject}`);
    if (this.state.selectedDPWorksite != null && this.state.selectedDPWorksite?.id != undefined)
    {
      this.DownloadAnnualDrillPlan(this.state.searchModel.calendarInfo.referenceYear, this.state.selectedDPWorksite.id, '');
      this.toggleDownloadAnnualReportModal();
    } else if(this.state.selectedDPProject != null && this.state.selectedDPProject?.id != undefined) {
      this.DownloadAnnualDrillPlan(this.state.searchModel.calendarInfo.referenceYear, '', this.state.selectedDPProject.id);
      this.toggleDownloadAnnualReportModal();
    } else {
      showNotification.warning(`${entitiesLabels.WARNING}`, `Please select a worksite or a project.`);
      this.forceUpdate();
    }
  }

  // RITM0860478
  DownloadAnnualDrillPlan(year, idWorksite, idProject) {
    console.log(`EmergencyDrillList.DownloadAnnualDrillPlan: year: ${year} idWorksite: ${idWorksite} idProject: ${idProject}`);
    var reqUrl = '';
    var fileName = 'Annual_Drill_Plan' + year + '.zip';
    if (idWorksite != '') {
      reqUrl = 'ws/' + year + '/' + idWorksite;
    } else if (idProject != '') {
      reqUrl = 'prj/' + year + '/' + idProject;
    } else {
      showNotification.error(`${entitiesLabels.ERROR}`,
        getError('No worksite or project selected!', entitiesLabels.EMERGENCYDRILL_ANNUALPLAN, apioperation.DOWNLOAD));
      return;
    }
    console.log(`EmergencyDrillList.DownloadAnnualDrillPlan: fileName: ${fileName}`);

    this.setState({
      isDownloadingAnnualDrillPlanFile: true,
    });
    api
      .getWithParam('/drill/exportannualdrillplan/' + reqUrl , {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        var data = new Blob([response.data], { type: 'application/zip' });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', fileName);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_ANNUALPLAN, apioperation.DOWNLOAD)
        );
      })
      .finally(() => {
        this.setState({
          isDownloadingAnnualDrillPlanFile: false,
         });
      });
  }

  getCalendar = async (param, isBack) => {
    console.log(`EmergencyDrillList.getCalendar: this.year: ${this.year}`);
    let isBackVar = false;
    if (isBack === undefined && this.state.isBack === true) {
      isBackVar = true;
    } else if (isBack === undefined && this.state.isBack === false) isBackVar = true;
    
    let data = null;
    let toFilter = null;
    this.setState({
      isLoadingTable: true,
    });

    if (!this.state.isBack || !isBackVar || this.state.searchModel?.entityInfo?.code) {
       toFilter = {
        params: {
          plannedWeeks: this.state.searchModel.calendarInfo?.plannedWeeks?.join(','),
          monthNumbers: this.state.searchModel.calendarInfo?.monthNumbers?.join(','),
          page: param && param.page ? param.page : this.state.paginationInfo?.currentPage,
          pageSize: param && param.pageSize ? param.pageSize : this.state.paginationInfo?.pageSize,
          IdCompany: this.state.searchModel?.entityInfo?.idCompany,
          IdDivision: this.state.searchModel?.entityInfo?.idDivision,
          IdWorkSite: this.state.searchModel?.entityInfo?.idWorkSite,
          IdProject: this.state.searchModel?.entityInfo?.idProject,
          IdDrillType: this.state.searchModel?.entityInfo?.idDrillType,
          IdDrillTypeDetail: this.state.searchModel?.entityInfo?.idDrillTypeDetail,
          DistributionList: '',
          PlannedYear: this.state.searchModel?.referenceYear === undefined ? 
            this.state.searchModel?.calendarInfo?.referenceYear : 
            this.state.searchModel?.referenceYear,
          IdFrequency: this.state.searchModel?.entityInfo?.idFrequency,
          IdParticipant: this.state.searchModel?.entityInfo?.idParticipant,
          CompilerEmail: this.state.searchModel?.entityInfo?.compilerEmail,
          DataApproverEmail: this.state.searchModel?.entityInfo?.dataApproverEmail,
          DrillerEmail: this.state.searchModel?.entityInfo?.drillerEmail,
          IdStatus: this.state.searchModel.entityInfo?.status?.id,
          ReferenceYear: this.state.searchModel?.referenceYear === undefined ? 
            this.state.searchModel?.calendarInfo?.referenceYear : 
            this.state.searchModel?.referenceYear,
          PlannedWeeks: this.state.searchModel?.calendarInfo?.plannedWeeks?.join(','),
          MonthNumbers: this.state.searchModel?.calendarInfo?.monthNumbers?.join(','),
          NeedToChange: this.state.searchModel?.calendarInfo?.needToChange,
          Weeks: this.state.searchModel?.calendarInfo?.weeks,
          Months: this.state.searchModel?.calendarInfo?.months,
          needToChange: this.state.searchModel?.needToChange,
          code: this.state.searchModel?.entityInfo?.code,
        }
      };
      this.year = this.state.searchModel?.referenceYear === undefined ? 
        this.state.searchModel?.calendarInfo?.referenceYear : this.state.searchModel?.referenceYear;
      this.setState({ isBack: false, isLoadingYear: false });
      data = toFilter;
    } else {
      const filter = await DrillRepository.getBackPaged();
      data = {
        params: filter.searchModel
      };
      toFilter = {
        params: {
          // RITM0549692
          page: 1,
          pageSize: filter && filter.paginationInfo && filter.paginationInfo.pageSize ? 
            filter.paginationInfo.pageSize : this.state.paginationInfo?.pageSize,
          //
          IdCompany: filter.searchModel?.entityInfo?.idCompany,
          IdDivision: filter.searchModel?.entityInfo?.idDivision,
          IdWorkSite: filter.searchModel?.entityInfo?.idWorkSite,
          IdProject: filter.searchModel?.entityInfo?.idProject,
          IdDrillType: filter.searchModel?.entityInfo?.idDrillType,
          IdDrillTypeDetail: filter.searchModel?.entityInfo?.idDrillTypeDetail,
          DistributionList: '',
          PlannedYear: filter.searchModel?.referenceYear === undefined ? 
            filter.searchModel?.calendarInfo?.referenceYear : this.state.searchModel?.referenceYear,
          IdFrequency: filter.searchModel?.entityInfo?.idFrequency,
          IdParticipant: filter.searchModel?.entityInfo?.idParticipant,
          CompilerEmail: filter.searchModel?.entityInfo?.compilerEmail,
          DataApproverEmail: filter.searchModel?.entityInfo?.dataApproverEmail,
          DrillerEmail: filter.searchModel?.entityInfo?.drillerEmail,
          IdStatus: filter.searchModel?.calendarInfo?.idStatus,
          ReferenceYear: filter.searchModel?.referenceYear === undefined ? 
            filter.searchModel?.calendarInfo?.referenceYear : this.state.searchModel?.referenceYear,
          PlannedWeeks: filter.searchModel?.calendarInfo?.plannedWeeks?.join(','),
          MonthNumbers: filter.searchModel?.calendarInfo?.monthNumbers?.join(','),
          NeedToChange: filter.searchModel?.calendarInfo?.needToChange,
          Weeks: filter.searchModel?.calendarInfo?.weeks,
          Months: filter.searchModel?.calendarInfo?.months,
          needToChange: filter.searchModel?.needToChange,
          code: filter.searchModel?.entityInfo?.code,
        }
      };
      this.year = filter.searchModel?.referenceYear === undefined ? 
        filter.searchModel?.calendarInfo?.referenceYear : this.state.searchModel?.referenceYear;

      this.setState((prevState) => ({
        searchModel: filter?.searchModel,
        calendar: filter.calendar,
        needToChange: (filter.calendar.length <= 0),
        referenceYear: filter.searchModel?.referenceYear === undefined ? 
          filter.searchModel?.calendarInfo?.referenceYear : prevState.searchModel?.referenceYear,
        PlannedYear: filter.searchModel?.referenceYear === undefined ? 
          filter.searchModel?.calendarInfo?.referenceYear : prevState.searchModel?.referenceYear,
      }));
      data = toFilter;
        this.setState({ isOpenSearchForm: false, isLoadingYear: false });
    }
    console.log(`EmergencyDrillList.getCalendar: this.year: ${this.year}`);
    this.getDrillListFilter(data);
    this.getDPWorksites();
    this.getDPProjects();
  }

  getDrillListFilter(filter) {
    drill
      .getCalendar(filter)
      .then((response) => {
        const { data } = response;

        response.data.itemList.forEach(
          (x) =>
            (x.plannedWeek =
              x.drillPlannedWeeks.length > 0 ? x.drillPlannedWeeks[0].weekNumber : null)
        );
        
        // response.data.itemList.forEach(x => x.division = x.workSite?.division);

        this.setState((prevState) => ({
          searchModel: { ...prevState.searchModel, needToChange: false },
          paginationInfo: {
            currentPage: data.currentPage,
            pageSize: data.pageSize,
            page: data.pageCount,
            rowCount: data.rowCount,
          },
          calendar: data.events?.fourMonthsList || prevState.calendar,
          items: data.itemList || prevState.items,
        }));
        this.year = this.state.searchModel?.referenceYear === undefined ? 
          this.state.searchModel?.calendarInfo?.referenceYear : 
          this.state.searchModel?.referenceYear;
        if (this.state.searchModel.needToChange && !this.state.isBack) {
          this.setState({
            calendar: data.events.fourMonthsList,
          });
          DrillRepository.updateDrillCalendarFilter(data);
        }
        const filterToCache = {
          searchModel: {
            calendarInfo: this.state.searchModel?.calendarInfo,
            entityInfo: this.state.searchModel?.entityInfo,
            needToChange: false,
          },
          calendar: this.state.calendar,
          // RITM0549692
          paginationInfo: {
            currentPage: data.currentPage,
            pageSize: data.pageSize
          },
        };
        DrillRepository.updateDrillFilter(filterToCache);
        this.setState(() => ({ isOpenSearchForm: false }));
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.GET));
        this.setState((prevState) => ({
          searchModel: { ...prevState.searchModel, needToChange: false },
        }));
      })
      .finally(() => {
        this.setState((prevState) => ({
          isLoadingTable: false,
          isLoadingCalendar: false,
          searchModel: { ...prevState.searchModel, needToChange: false },
        }));
      });
  }

  handleChangePaging = async (event) => {
    await this.setState((prevState) => ({
      paginationInfo: {
        currentPage: event.page,
        pageSize: event.pageSize,
        page: event.page,
        rowCount: event.rowCount,
      },
      searchModel: {
        ...prevState.searchModel,
        needToChange: false,
      },
      isBack: false
    }));
    this.getCalendar(event);
  };

  searchDrills = (e, currentSearchModal) => {
    e.preventDefault();
    if (!currentSearchModal.isBack) {
      this.setState({ isBack: false });
    }
    const infoFilter = currentSearchModal;
    this.toogleFilterModal(e);
    this.setState((prevState) => (
      {
        searchModel: {
          ...prevState.searchModel,
          entityInfo: { ...infoFilter },
          calendarInfo: {
            plannedWeeks: [],
            monthNumbers: [],
            referenceYear: prevState.searchModel.calendarInfo.referenceYear,
          },
          needToChange: true,
          calendar: [],
        },
      }),
      () => {
        this.getCalendar({ page: 1 }, false);
      }
    );
  };

  cancelFilters = (e,) => {
    e.preventDefault();
    this.setState({ isBack: false });
    this.toogleFilterModal(e);
    this.setState(
      {
        isLoadingYear: true,
        searchModel: {
          ...this.searchProp(),
          needToChange: true,
        },
      },
      () => {
        this.getCalendar({ page: 1 }, false);
      }
    );
  };

  closeFilters = (e) => {
    this.toogleFilterModal(e);
  };

  searchProp = () => ({
    entityInfo: {
      id: null,
      idDivision: null,
      idCompany: null,
      idWorkSite: null,
      idProject: null,
      idStatus: null,
      idParticipant: null,
      idFrequency: null,
      idDrillType: null,
      idDrillTypeDetail: null,
      code: this.getHashtag(),
      compilerEmail: null,
      dataApproverEmail: null,
      drillerEmail: null,
    },
    calendarInfo: {
      plannedWeeks: [],
      referenceYear: new Date().getFullYear(),
      monthNumbers: [],
    },
  });

  buildFilter = (items, filters) => {
    const filteredItems =
      filters !== null ? items.filter((item) => this.checkItem(item, filters)) : items;
    this.setState(() => ({
      items: filteredItems,
    }));
    return filteredItems;
  };

  checkItem = (item, filters) => {
    Object.keys(filters).forEach((key) => {
        if (
          typeof filters[key] !== 'object' &&
          filters[key] !== '' &&
          filters[key] != null &&
          filters[key] !== item[key]
        ) { return false; }

        if (
          Array.isArray(filters[key]) &&
          JSON.stringify(filters[key]) !== JSON.stringify(item[key])
        ) { return false; }
        if (filters[key] != null && item[key].name !== filters[key].name) return false;
        return true;
      }
    );
    return true;
  };

  applyFilters = (filters, apply) => {
    this.setState((state) => ({
      items: this.buildFilter(state.originalItems, apply ? filters : null),
    }));
  };

  showAddEDrill() {
    this.setState((oldState) => ({
      modalEDrillVisible: !oldState.modalEDrillVisible,
      eDrillToModify: null,
    }));
  }

  showEditEDrill(row) {
    const eDrillToEdit = this.state.items.find((item) => item.id === row.id);
    if ((eDrillToEdit.drillModifiedPlannedWeekSets != null) &&
      (eDrillToEdit.drillModifiedPlannedWeekSets !== undefined) && 
      (eDrillToEdit.drillModifiedPlannedWeekSets.length > 0)) {
        this.setState(() => ({ eDrillToModify: eDrillToEdit }));
        this.getModifiedPlannedWeekSetCompiler(
            eDrillToEdit.drillModifiedPlannedWeekSets[0].idCompiler, this.showEditEDrillWarning);
        return;
    }
    this.setState((oldState) => ({
      modalEDrillVisible: !oldState.modalEDrillVisible,
      eDrillToModify: eDrillToEdit
    }));
  }

  showEditEDrillWarning = (compiler) => {
    if (compiler != null) {
      this.setState((prevState) => ({ isWarningModalOpen: !prevState.isWarningModalOpen, warningMessage: `Changes to the planned weeks already compiled by ${compiler.surname} ${compiler.name}` }));
    }
  }

  toggleWarningModal = () => {
    this.setState((prevState) => ({
      isWarningModalOpen: !prevState.isWarningModalOpen,
      eDrillToModify: null
    }));
  };

  handleConfirmWarningModal = () => {
    this.setState((prevState) => ({ isWarningModalOpen: !prevState.isWarningModalOpen, 
                                    modalEDrillVisible: !prevState.modalEDrillVisible, })
    );
  };

  handleChangeWorksite = (el) => {
    console.log(`EmergencyDrillList.handleChangeWorksite: Worksite id: ${el.selectedItem?.id} Worksite: ${el.selectedItem?.name}`);
    const inputValue = el.selectedItem;
    const worksite = this.state.worksites.find((item) => item.id === inputValue.id);
    this.setState(() => ({
      selectedWorksite: { ...worksite },
    }));
  };

  // RITM0860478
  handleChangeDPWorksite = (el) => {
    console.log(`EmergencyDrillList.handleChangeDPWorksite: Worksite id: ${el.selectedItem?.id} Worksite: ${el.selectedItem?.name}`);
    const inputValue = el.selectedItem;
    console.log(`EmergencyDrillList.handleChangeDPWorksite: inputValue: ${inputValue}`);
    var worksite = null;
    const project = null;
    if (inputValue != null)
      worksite = this.state.dpWorksites.find((item) => item.id === inputValue.id);
    this.setState(() => ({
      selectedDPWorksite: { ...worksite },
      selectedDPProject: { project},
    }));
    this.forceUpdate();
  };

  // RITM0860478
  handleChangeDPProject = (el) => {
    console.log(`EmergencyDrillList.handleChangeDPProject: Project id: ${el.selectedItem?.id} Project: ${el.selectedItem?.name}`);
    const inputValue = el.selectedItem;
    console.log(`EmergencyDrillList.handleChangeDPProject: inputValue: ${inputValue}`);
    const worksite = null;
    var project = null;
    if (inputValue != null)
      project = this.state.dpProjects.find((item) => item.id === inputValue.id);
    this.setState(() => ({
      selectedDPWorksite: { worksite },
      selectedDPProject: { ...project },
    }));
    this.forceUpdate();
  };

  renderWorksiteSelectionModal = () => {
    const selectedItemCombo = {
      idWorkSite: this.state.selectedWorksite
        ? (this.state.worksites || []).find((el) => el.id === this.state.selectedWorksite.id)
        : [],
    };
    const validatorworksite = {
      worksite: this.validatorworksite.message('worksite', this.state.selectedWorksite?.id, 'required'),
    };
    return (
      <ComposedModal className="light-modal-half-height" open={this.state.isWorksiteModalOpen} danger="false" onClose={() => false}>
        <ModalHeader className="margin-modal" buttonOnClick={this.closeWorksiteModal}>
          <p>Upload the Annual drill plan document - select the Worksite</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div>
            <Form className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12">
                  <FormLabel>Worksite*</FormLabel>
                  {this.state.isLoadingWorksite ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key="idWorkSite"
                      id="idWorkSite"
                      placeholder="Select"
                      name="idWorkSite"
                      alt="search"
                      onChange={this.handleChangeWorksite}
                      itemToString={(item) => (item ? item.name : '')}
                      invalid={validatorworksite.worksite != null}
                      selectedItem={
                        selectedItemCombo.idWorkSite ? selectedItemCombo.idWorkSite : null
                      }
                      items={this.state.worksites}
                    />
                  )}
                  {validatorworksite.worksite}
                </FormGroup>
              </div>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={this.closeWorksiteModal}>
            Cancel
          </Button>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={this.onConfirmWorksiteModal}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }

  // RITM0860478
  renderDownloadAnnualDrillPlanModal = () => {
    console.log(`EmergencyDrillList.renderDownloadAnnualDrillPlanModal: this.year: ${this.year}`);
    const selectedDPItemCombo = {
      idWorkSite: this.state.selectedDPWorksite
        ? (this.state.dpWorksites || []).find((el) => el.id === this.state.selectedDPWorksite.id)
        : [],
      idProject: this.state.selectedDPProject
        ? (this.state.dpProjects || []).find((el) => el.id === this.state.selectedDPProject.id)
        : [],
    };
    return (
      <ComposedModal className="light-modal-half-height" open={this.state.isDownloadAnnualReportOpen} danger="false" onClose={() => false}>
        <ModalHeader className="margin-modal" buttonOnClick={this.closeDownloadAnnualReportModal}>
          <p>Download the Annual drill plan document - select the Worksite or Project</p>
        </ModalHeader>
        <ModalBody>
          <div>
            <Form className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12">
                  <FormLabel>Worksite**</FormLabel>
                  {this.state.isLoadingDPWorksite ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key="idWorkSite"
                      id="idWorkSite"
                      placeholder="Select"
                      name="idWorkSite"
                      alt="search"
                      onChange={this.handleChangeDPWorksite}
                      itemToString={(item) => (item ? item.name : '')}
                      selectedItem={
                        selectedDPItemCombo.idWorkSite ? selectedDPItemCombo.idWorkSite : null
                      }
                      items={this.state.dpWorksites}
                    />
                  )}
                </FormGroup>
              </div>
              <div className="bx--row">
                <FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12">
                  <FormLabel>Project**</FormLabel>
                  {this.state.isLoadingDPProjects ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      key="idProject"
                      id="idProject"
                      placeholder="Select"
                      name="idProject"
                      alt="search"
                      onChange={this.handleChangeDPProject}
                      itemToString={(item) => (item ? item.name : '')}
                      selectedItem={
                        selectedDPItemCombo.idProject ? selectedDPItemCombo.idProject : null
                      }
                      items={this.state.dpProjects}
                    />
                  )}
                </FormGroup>
              </div>
            </Form>
            ** Select a Worksite OR a Project
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={this.closeDownloadAnnualReportModal}>
            Cancel
          </Button>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={this.onConfirmDownloadAnnualDrillPlanModal}
          >
            Search
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }

  getWorkSiteAttachment = async () => {
    if (this.state.selectedWorksite != null) {
      this.setState(() => ({ isSubmitted: true }));
      let items = [];
      try {
        items = (await drill.getAllWorksiteAttachments(this.state.selectedWorksite.id)).data;
        this.setState(() => ({ worksiteAttachments: [...items] }));
      } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_WORKSITEATTACHMENT, apioperation.GET));
      } finally {
        this.setState(() => ({ isSubmitted: false }));
      }
    }
  }

  onCloseWorkSiteAttachmentModal = () => {
    this.validatorworksite.hideMessages();
    this.setState(() => ({ selectedWorksite: null }));
    this.toggleEDrillWorkSiteAttachmentModal();
  }

  toggleEDrillWorkSiteAttachmentModal = () => {
    this.setState((prevState) => ({ isEDrillWorkSiteAttachmentModalOpen: 
                                    !prevState.isEDrillWorkSiteAttachmentModalOpen }));
  }

  renderEDrillWorkSiteAttachmentModal = () => (
    <EDrillWorkSiteAttachmentModal
      onCloseWorkSiteAttachmentModal={this.onCloseWorkSiteAttachmentModal}
      selectedWorksite={this.state.selectedWorksite}
      showWorkSiteAttachmentModal={this.state.isEDrillWorkSiteAttachmentModalOpen}
      initialWorksiteAttachment={this.state.worksiteAttachments}
    />
  )

  filterByWeek = (weekNumber) => {
    this.setState({ isBack: false });
    const isBack = false;
    let year;
    try {
      year = this.state.searchModel.calendarInfo?.referenceYear;
      const statusCopy = { ...this.state };
      statusCopy.searchModel.calendarInfo.referenceYear = year;

      const index = statusCopy.searchModel.calendarInfo.plannedWeeks.indexOf(weekNumber);
      if (index > -1) statusCopy.searchModel.calendarInfo.plannedWeeks.splice(index, 1);
      else statusCopy.searchModel.calendarInfo.plannedWeeks.push(weekNumber);

      statusCopy.searchModel.needToChange = false;
      statusCopy.isBack = false;
      statusCopy.isfilterByWeek = true;
      this.setState(statusCopy);
      this.getCalendar({ page: 1 }, isBack);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.GET));
    } 
  };

  filterByMonths = (month) => {
    this.setState({ isBack: false });
    const isBack = false;
    let year;
    try {
      year = this.state.searchModel.calendarInfo.referenceYear;
      const statusCopy = { ...this.state };
      statusCopy.searchModel.calendarInfo.referenceYear = year;
      statusCopy.isBack = false;
      const index = statusCopy.searchModel.calendarInfo.monthNumbers.indexOf(month.monthsNumber);
      if (index > -1) statusCopy.searchModel.calendarInfo.monthNumbers.splice(index, 1);
      else statusCopy.searchModel.calendarInfo.monthNumbers.push(month.monthsNumber);

      statusCopy.searchModel.needToChange = false;
      statusCopy.isfilterByWeek = true;
      this.setState(statusCopy);
      this.getCalendar({ page: 1 }, isBack);
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.GET));
    }
  };

  toogleFilterModal(e) {
    e.preventDefault();
    this.setState((oldState) => ({
      isOpenSearchForm: !oldState.isOpenSearchForm,
    }));
  }

  //  *************** CALENDAR *************** END

  async newEDrillAdded(item) {
    await DrillRepository.updateCachedDrillList(item, item.plannedYear);
    const drills = await DrillRepository.getCachedDrillList(
      this.state.searchModel.calendarInfo.referenceYear
    );
    this.setState((prevState) => ({
      originalItems: drills.itemList,
      items: this.buildFilter(drills.itemList, null, null),
      modalEDrillVisible: !prevState.modalEDrillVisible,
      searchModel: {
        ...prevState.searchModel,
        needToChange: true,
      },
    }));
    this.getCalendar();
  }

  async refreshData() {
    this.setState((prevState) => ({
      loading: true,
      searchModel: {
        ...prevState.searchModel,
        needToChange: true,
      },
    }));
    this.getCalendar();
  }

  eDrillPlannedUpdated(deletedPlannedWeek, addedPlannedWeek, changedPlannedWeek) {
    const idEntity = this.state.eDrillToModify.workSite?.idDivision;
    this.setState((prevState) => ({ modalEDrillVisible: !prevState.modalEDrillVisible, 
              isLoadingApproverOptions: true,
              modalEDrillPlanModificationVisible: !prevState.modalEDrillPlanModificationVisible,
              modifiedPlannedWeekSet: {
                ...prevState.modifiedPlannedWeekSet,
                deletedPlannedWeek: [...deletedPlannedWeek],
                addedPlannedWeek: [...addedPlannedWeek],
                updatedPlannedWeek: [...changedPlannedWeek]
              } }));
    this.getApprovers(idEntity);
  }

  renderLoadingModal = () => {
    const show = this.state.isSubmitted || this.state.isLoadingModifiedPlannedWeekSetCompiler
              || this.state.isDownloadingAnnualDrillPlanFile // RITM0860478
              || this.state.isLoadingDPWorksites // RITM0860478
              || this.state.isLoadingDPProjects; // RITM0860478
    console.log(`EmergencyDrillList.renderLoadingModal: show: ${show}`);
    return show && <Loading active withOverlay description={this.state.isSubmitted ? 'Saving...' : 'Loading...'} />;
  };

  render() {
    console.log(`EmergencyDrillList.render: this.year: ${this.year}`);
    const validations = ((this.state.modifiedPlannedWeekSet !== null && 
                          this.state.modifiedPlannedWeekSet !== undefined) ? {
      toDelete: this.state.modifiedPlannedWeekSet?.deletedPlannedWeek?.map((e, index) => (this.validator.message(`Reason for change delete week ${this.state.modifiedPlannedWeekSet.deletedPlannedWeek[index].weekNumber} # ${this.state.modifiedPlannedWeekSet.deletedPlannedWeek[index].sequence}`, this.state.modifiedPlannedWeekSet.deletedPlannedWeek[index].reasonForChange, 'required'))),
      toAdd: this.state.modifiedPlannedWeekSet?.addedPlannedWeek?.map((e, index) => (this.validator.message(`Reason for change add week ${this.state.modifiedPlannedWeekSet.addedPlannedWeek[index].weekNumber} # ${this.state.modifiedPlannedWeekSet.addedPlannedWeek[index].sequence}`, this.state.modifiedPlannedWeekSet.addedPlannedWeek[index].reasonForChange, 'required'))),
      toUpdate: this.state.modifiedPlannedWeekSet?.updatedPlannedWeek?.map((e, index) => (this.validator.message(`Reason for change update week ${this.state.modifiedPlannedWeekSet.updatedPlannedWeek[index].weekNumber} # ${this.state.modifiedPlannedWeekSet.updatedPlannedWeek[index].sequence}`, this.state.modifiedPlannedWeekSet.updatedPlannedWeek[index].reasonForChange, 'required'))),
    } : null);

    return (
      <AppContext.Consumer>
        {({ user }) =>
          IsEnabled(user, 'Emergency Drill') ? (
            <>
              <PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Drill Plan List" />
              <div className="mainContainer">
                <div className="headerPlanContainer">
                  {!this.state.isLoadingYear ? 
                    <h4 className="description-page">
                      Current year
                      <Dropdown
                        label=""
                        id="CurrentYearDrillDropDown"
                        items={this.state.years}
                        onChange={this.onYearChange}
                        initialSelectedItem={this.year}
                        itemToString={(item) => item || ''}
                        type="inline"
                      />
                    
                    </h4>
                  : null }
                  <div>
                    <table className="table-legend-drill">
                      <EDLegendTable 
                        arrLegend={[LegendType.RED_PLAN, 
                                    LegendType.ORANGE_PLAN, 
                                    LegendType.GREEN_PLAN]} 
                      />
                    </table>
                  </div>
                  <div className="header-custom-toolbar">
                    <TableToolbar>
                      {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') ? (
                        <Button 
                          className="buttonPaddingIcon" 
                          iconDescription="Drill Plan Attachment" 
                          renderIcon={Attachment16} 
                          onClick={this.toggleWorksiteModal}
                        />
                      ) : null}
                      <Button
                        onClick={this.toogleCalendar}
                        className="buttonPaddingIcon"
                        renderIcon={Calendar16}
                        iconDescription="Filter"
                      />
                      <Button
                        onClick={this.toogleFilterModal}
                        className="buttonPaddingIcon"
                        renderIcon={Data16}
                        iconDescription="Filter"
                      />
                      {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') ? (
                        <Button renderIcon={Add16} onClick={this.showAddEDrill}>
                          New Drill Plan
                        </Button>
                        ) : null}
                        <Button
                        onClick={this.toggleDownloadAnnualReportModal}
                            className="buttonPaddingIcon"
                        >
                            Download Annual Drill Plan
                        </Button>
                    </TableToolbar>
                  </div>
                </div>
                {/* CALENDAR */}
                <div
                  style={{
                    display: this.state.isOpenCalendar ? 'block' : 'none',
                  }}
                >
                  {this.state.searchModel.needToChange ? (
                    <div className="layout-skeleton-calendar">
                      <Loading withOverlay />
                      <table className="table-layout-custom">
                        <CalendarSkeleton />
                      </table>
                    </div>
                  ) : (
                    <table className="table-layout-custom">
                      <InspectionMonthHeader
                        calendar={this.state.calendar}
                        onSelectWeek={this.filterByWeek}
                        onSelectMonth={this.filterByMonths}
                        monthsSelected={this.state.monthsSelected}
                        weeksSelected={this.state.weeksSelected}
                        isDrill
                      />
                    </table>
                  )}
                </div>

                <div className="bx--grid content full-width mainContainer ">
                  {this.state.isOpenSearchForm ? (
                    <DrillFilterModal
                      checkBack={this.state.isBack}
                      searchModel={this.state.searchModel.entityInfo}
                      onSearch={this.searchDrills}
                      onCancel={this.cancelFilters}
                      onClose={this.closeFilters}
                    />
                  ) : null}
                  {this.state.modalEDrillVisible ? (
                    <EDrillDetails
                      EDrill={this.state.eDrillToModify}
                      onCancel={this.showAddEDrill}
                      onSave={this.newEDrillAdded}
                      onUpdate={this.eDrillUpdated}
                      onDrillPlannedUpdate={this.eDrillPlannedUpdated}
                      user={user}
                    />
                  ) : null}
                  {this.state.modalEDrillPlanModificationVisible ? (
                    <EDrillPlanModificationModal
                      plannedWeekToDelete={this.state.modifiedPlannedWeekSet.deletedPlannedWeek}
                      plannedWeekToAdd={this.state.modifiedPlannedWeekSet.addedPlannedWeek}
                      plannedWeekToUpdate={this.state.modifiedPlannedWeekSet.updatedPlannedWeek}
                      approvers={this.state.modifiedPlannedWeekSet.approvers}
                      approver={this.state.modifiedPlannedWeekSet.approver}
                      isLoadingOperation={this.state.isLoadingApproverOptions}
                      onShow={this.state.modalEDrillPlanModificationVisible}
                      onCancel={this.onCancelEDrillPlannedModification}
                      onConfirm={this.onSaveEDrillPlannedModification}
                      onApproverSelect={this.onApproverSelect}
                      onUpdateReasonForChange={this.onUpdateReasonForChange}
                      validations={validations}
                    />
                  ) : null}
                  {this.state.isLoadingTable ? (
                    <DataTableSkeleton />
                  ) : (
                    <EDrillMultiSelectDataTable
                      eDrills={this.state.items || []}
                      onNewEDrill={this.showAddEDrill}
                      onEditEDrill={this.showEditEDrill}
                      onStatusChanged={this.eDrillUpdated}
                      onRefreshData={this.refreshData}
                      onDelete={this.onDelete}
                      applyFilters={this.applyFilters}
                      onWaitingSubmit={this.toggleIsSubmitted}
                      toogleFilterModal={this.toogleFilterModal}
                      handleChangePaging={this.handleChangePaging}
                      paginationInfo={this.state.paginationInfo}
                    />
                  )}
                </div>
                {this.state.isWarningModalOpen ? (
                  <WarningModal
                    message={this.state.warningMessage}
                    onCancel={this.toggleWarningModal}
                    onConfirm={this.handleConfirmWarningModal}
                  />
                ) : null}
                {this.renderLoadingModal()}
                {this.renderWorksiteSelectionModal()}
                {this.renderEDrillWorkSiteAttachmentModal()}
                {this.renderDownloadAnnualDrillPlanModal()}
              </div>
            </>
          ) : null
        }
      </AppContext.Consumer>
    );
  }
}

EmergencyDrillList.propTypes = {
  history: PropTypes.shape({
    block: PropTypes.func,
    createHref: PropTypes.func,
    go: PropTypes.func,
    goBack: PropTypes.func,
    goForward: PropTypes.func,
    listen: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func,
    length: PropTypes.number,
    action: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      key: PropTypes.string
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    key: PropTypes.string
  }).isRequired
};
